// class handling trust arc and cookies

import {cookieExist} from "../helpers/document-helper";

export class TrustArc {

    private static readonly TRUST_ARC_PRIVACY_COOKIE_NAME = 'cmapi_cookie_privacy';

    public static loadTrustArcScript(): Promise<void> {
        return new Promise((resolve) => {
            const tag = document.createElement('script');
            //FORCE US mode for debugging - add &country=us to script source;
            //FORCE NON INTRUSIVE MODE tag.src = 'https://consent.trustarc.com/notice?domain=idc.com&c=teconsent&js=nj&noticeType=bb&gtm=1&behavior=implied';
            tag.src = 'https://consent.trustarc.com/notice?domain=idc.com&c=teconsent&js=nj&noticeType=bb&gtm=1';
            tag.async = false;

            // Event listener for successful script loading
            tag.addEventListener('load', () => {
                resolve();
            });

            document.head.appendChild(tag);
        });
    }

    public static trustArcCookiesExist() {
        return cookieExist(TrustArc.TRUST_ARC_PRIVACY_COOKIE_NAME);
    }

    public static trustArcEnabled() {
        // trustarc not enabled on localhost
        return !window.location.hostname.includes('localhost')
    }
}
